import type { Flow___SubjectIdentifier } from '../Selector/utils/getSubject';

/**
 * The only subject an address field may point to.
 * The API rejects any pointer that does not resolve to this subject.
 */
export const ADDRESS_SUBJECT: Flow___SubjectIdentifier = {
  type: 'FlowSubject_Primitive_Address',
  typeId: null,
};
